class StaffFilter {
  showOnlyAssignedToMe = false;
  showBasicMembers = false;
  showDefaultAdministrators = false;
  showDefaultSupervisors = false;
  showCustomRoles = false;
  showInactiveMembers = false;

  constructor(valuesObj?: StaffFilter) {
    if (!valuesObj) {
      return this;
    }
    const copy = JSON.parse(JSON.stringify(valuesObj));

    this.showOnlyAssignedToMe = copy.showOnlyAssignedToMe || false;
    this.showBasicMembers = copy.showBasicMembers !== undefined ? copy.showBasicMembers : true;
    this.showDefaultAdministrators = copy.showDefaultAdministrators !== undefined ? copy.showDefaultAdministrators : true;
    this.showDefaultSupervisors = copy.showDefaultSupervisors !== undefined ? copy.showDefaultSupervisors : true;
    this.showCustomRoles = copy.showCustomRoles !== undefined ? copy.showCustomRoles : true;
    this.showInactiveMembers = copy.showInactiveMembers || false;

    return this;
  }

  clear() {
    this.showOnlyAssignedToMe = false;
    this.showBasicMembers = false;
    this.showDefaultAdministrators = false;
    this.showDefaultSupervisors = false;
    this.showCustomRoles = false;
    this.showInactiveMembers = false;
    return this;
  }

  copyValues() {
    return new StaffFilter(this);
  }

  setValues(valuesObj: StaffFilter) {
    this.showOnlyAssignedToMe = valuesObj.showOnlyAssignedToMe !== undefined ? valuesObj.showOnlyAssignedToMe : this.showOnlyAssignedToMe;
    this.showBasicMembers = valuesObj.showBasicMembers !== undefined ? valuesObj.showBasicMembers : this.showBasicMembers;
    this.showDefaultAdministrators = valuesObj.showDefaultAdministrators !== undefined ? valuesObj.showDefaultAdministrators : this.showDefaultAdministrators;
    this.showDefaultSupervisors = valuesObj.showDefaultSupervisors !== undefined ? valuesObj.showDefaultSupervisors : this.showDefaultSupervisors;
    this.showCustomRoles = valuesObj.showCustomRoles !== undefined ? valuesObj.showCustomRoles : this.showCustomRoles;
    this.showInactiveMembers = valuesObj.showInactiveMembers !== undefined ? valuesObj.showInactiveMembers : this.showInactiveMembers;
    return this;
  }

  resetAll() {
    this.clear();
    return this;
  }

  resetGeneral() {
    this.clear();
  }

  // Helper method to get selected roles
  getSelectedRoles(): string[] {
    const roles: string[] = [];
    if (this.showBasicMembers) roles.push('basic');
    if (this.showDefaultAdministrators) roles.push('administrator');
    if (this.showDefaultSupervisors) roles.push('supervisor');
    if (this.showCustomRoles) roles.push('custom');
    return roles;
  }
}

export { StaffFilter };
